import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { useHistory } from "react-router";
import { GridRowModes } from "@mui/x-data-grid";
import { Tooltip } from "@mui/material";
import { Card, Input, Container, Row } from "reactstrap";

import { putpost, putpost2 } from "services/http";
import { endpoint } from "../../common/constant";
import { ReactComponent as BackIcon } from "assets/img/svg/BackButton.svg";

import CustomButton from "components/CustomButton";
import { ReactComponent as ActiveControl } from "assets/img/svg/ActiveControl.svg";
import { ReactComponent as InactiveControl } from "assets/img/svg/InactiveControl.svg";

import AChip from "../../common/chip/AChip";
import { isObjEmpty } from "../pincode/constants";
import { AGridColDef } from "../../common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { LastUpdatedDetails } from "../../employeeManagement/userProfile/helper";
import { editCellContainerStyle } from "../../edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import {
  failureToast,
  successToast,
} from "../../common/utils/methods/toasterFunctions/function";
import { capitalize } from "../../common/utils/methods/commonMethods/utilityMethod";

import { NEW_EMPTY_ROW, getStudentCategories } from "./helper";

const StudentCategoryTable = ({ userPermissions, isLoading, setIsLoading }) => {
  const history = useHistory();

  const [apiResponse, setApiResponse] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [rowForm, setRowForm] = useState({});
  const [rowModesModel, setRowModesModel] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const [isSaveVisible, setisSaveVisible] = useState(false);
  const [pageSize, setPageSize] = useState(50);

  useEffect(() => {
    fetchStudentCategory();
  }, []);

  useEffect(() => {
    setRowData(apiResponse);
  }, [apiResponse]);

  const fetchStudentCategory = async (page = 0, pageSize) => {
    setIsLoading(true);

    const response = await getStudentCategories(page, pageSize);

    if (response.totalPages) {
      const { content, totalElements } = response;
      setApiResponse(content);
      setTotalRows(totalElements);
    }
    setIsLoading(false);
  };

  const rowFormHandler = (value, key) => {
    setRowForm((prev) => ({ ...prev, [key]: value }));
  };

  const startEditing = (id, form) => {
    setRowModesModel((oldModel) => ({
      [id]: { mode: GridRowModes.Edit, fieldToFocus: "countryId" },
    }));

    setRowForm(form);
  };

  const stopEditing = (id) => {
    const currForm = { ...rowForm };

    setRowModesModel((oldModel) => ({
      [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
    }));
    setRowForm({});
  };

  const columns = [
    new AGridColDef("displayValue", "Display Value")
      .setFlex(0.3)
      .columnAlign("center")
      .editable(true)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      )
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <Input
            maxLength="50"
            defaultValue={rowForm?.displayValue}
            onChange={(e) => {
              rowFormHandler(e.target.value, "displayValue");
            }}
            placeholder="Display Value"
            className="tdInput"
          />
        </div>
      )),

    new AGridColDef("description", "Description")
      .setMinWidth(300)
      .editable(true)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      )
      .renderEditCellComponent((params) => {
        return (
          <div style={editCellContainerStyle}>
            <Input
              maxLength="50"
              defaultValue={rowForm?.description}
              onChange={(e) => {
                rowFormHandler(e.target.value, "description");
              }}
              placeholder="Description"
              className="tdInput"
            />
          </div>
        );
      }),

    new AGridColDef("lastUpdated", "Last Updated On")
      .setFlex(0.5)
      .columnAlign("left")
      .editable(false)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip
            title={LastUpdatedDetails(params?.value, params?.row.updatedBy)}
          >
            <div className={`ellipsis-text-container`}>
              {LastUpdatedDetails(params?.value, params?.row.updatedBy)}
            </div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("status", "Status")
      .setFlex(0.2)
      .columnAlign("center")
      .editable(true)
      .renderCellComponent((params) => (
        <AChip
          label={capitalize(params?.value)}
          success={params.value?.toUpperCase() === "ACTIVE"}
        />
      ))
      .renderEditCellComponent((params) => {
        return (
          <div style={editCellContainerStyle} className="text-center">
            <span>
              {rowForm?.status?.toUpperCase() === "ACTIVE" ? (
                <ActiveControl
                  onClick={() => rowFormHandler("INACTIVE", "status")}
                />
              ) : (
                <InactiveControl
                  onClick={() => rowFormHandler("ACTIVE", "status")}
                />
              )}
              <span className="ml-1">Active</span>
            </span>
          </div>
        );
      }),

    new AGridColDef("actions", "Action", false)
      .setFlex(0.3)
      .pinColumnLast(true)
      .renderCellComponent((params) =>
        params.api.getRowMode(params?.id) === "view" ? (
          <>
            <CustomButton
              content={""}
              permissionType={"U"}
              icon={true}
              forTable={true}
              onClick={() => {
                handleEditClick(params);
              }}
              permissionSet={userPermissions}
            />

            <CustomButton
              content={""}
              permissionType={"D"}
              icon={true}
              forTable={true}
              onClick={() => {
                deleteRow(params.id);
              }}
              permissionSet={userPermissions} // for SuperAdmins only
            />
          </>
        ) : (
          <>
            <CustomButton
              content={"Save"}
              permissionType={"C,U"}
              icon={false}
              forTable={true}
              onClick={() => {
                // stopEditing(rowId);
                saveAll(params.row.id);
              }}
              permissionSet={userPermissions}
            />
            <CustomButton
              content={""}
              permissionType={"cancel"}
              icon={true}
              forTable={true}
              onClick={() => {
                handleCancelClick(params);
              }}
              permissionSet={userPermissions}
            />
          </>
        )
      ),
  ];

  const newRow = () => {
    if (!isObjEmpty(rowForm)) {
      failureToast("Please Delete or Save current changes");
    } else {
      let randomId = uuidv4();
      let emptyRow = {
        ...NEW_EMPTY_ROW,
        id: randomId,
      };
      startEditing(randomId, emptyRow);
      setRowData((prev) => [emptyRow, ...prev]);
      setisSaveVisible(true);
    }
  };

  const handleEditClick = (params) => {
    if (!isObjEmpty(rowForm)) {
      failureToast("Please Delete or Save current changes");
    } else {
      startEditing(params?.id, params?.row);
    }
  };

  const handleCancelClick = async (params) => {
    stopEditing(params?.id);

    if (params?.row?.isNew) {
      setRowData(apiResponse);
      setRowForm({});
    }
  };

  const deleteRow = (rowId) => {
    if (window.confirm("Are you sure you want to delete this State?")) {
      setIsLoading(true);
      putpost2(
        `${endpoint?.studentCategories}/` + rowId,
        (data) => {
          successToast(data["message"]);
          setisSaveVisible(false);
          // setRowData(rowData.filter((obj) => obj.id !== rowId));
          setApiResponse(apiResponse.filter((obj) => obj.id !== rowId));
        },
        (data) => {
          failureToast(data["message"]);
        },
        "Delete"
      );

      setIsLoading(false);
    }
  };

  const saveAll = async (rowId) => {
    if (!rowForm["displayValue"]) {
      failureToast("Please enter the value of Display value");
      return;
    } else if (
      rowForm["description"] === null ||
      !rowForm["description"].trim()
    ) {
      failureToast("Please enter the value of description");
      return;
    }

    const modifiedPayload = {
      displayValue: rowForm.displayValue,
      description: rowForm.description,
      status: rowForm.status,
    };

    setIsLoading(true);
    if (rowForm?.isNew) {
      putpost(
        endpoint?.studentCategories,
        (data) => {
          successToast(data["message"]);
          setisSaveVisible(false);
          stopEditing(rowId);

          setApiResponse([...apiResponse, data.data]);
        },
        (data) => {
          failureToast(data["message"]);
        },
        modifiedPayload,
        "post"
      );
    } else {
      putpost(
        `${endpoint?.studentCategories}/` + rowId,
        (data) => {
          successToast(data["message"]);
          setisSaveVisible(false);
          stopEditing(rowId);

          setApiResponse(
            apiResponse.map((obj) => (obj.id === rowId ? data.data : obj))
          );
        },
        (data) => {
          failureToast(data["message"]);
        },
        modifiedPayload,
        "put"
      );
    }
    setIsLoading(false);
  };

  const nextButtonHandler = (pageNum, updatedPageSize) => {
    setCurrentPage(pageNum);
    setPageSize(updatedPageSize);

    fetchStudentCategory(pageNum, updatedPageSize);
  };

  return (
    <>
      <Container className="mt-3" fluid>
        <Row>
          <div className="col">
            <Card>
              <div className="border-0 p-4">
                <div className="w-100 d-flex justify-content-between align-items-center">
                  <div
                    className={`d-flex align-items-center`}
                    style={{ height: "min-content" }}
                  >
                    <BackIcon
                      className="mr-2 large-text"
                      onClick={() => history.goBack()}
                    />
                    <div className="heading-3 color-black-60 text-bold">
                      Student Category Master
                    </div>
                  </div>

                  <div className="d-flex justify-content-center align-items-center">
                    <CustomButton
                      className={
                        "mb-0" + isSaveVisible ? " btn-dark cursor-gray" : null
                      }
                      content={"Add New"}
                      permissionType={"C"}
                      icon={true}
                      onClick={() => {
                        newRow();
                      }}
                      forTable
                      permissionSet={userPermissions}
                    />
                  </div>
                </div>
              </div>

              <div style={{ height: "72vh", maxHeight: "75vh" }}>
                <ADataGrid
                  removeWrapperContainer
                  rowModesModel={rowModesModel}
                  rows={rowData || []}
                  columns={columns}
                  rowId={(row) => row.id}
                  rowHeight={50}
                  loading={false}
                  rowCount={totalRows}
                  nextButtonHandler={nextButtonHandler}
                  currentPage={currentPage}
                  pinLastColumn
                  paginationModel={{
                    page: currentPage,
                    pageSize: pageSize,
                  }}
                />
              </div>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default StudentCategoryTable;
